import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { resolveImageUrl } from "@/context/SettingsContext";

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}

export function ImageUploadButton({ onUploaded, label = "Add Cover", testid, className = "" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      onUploaded(await uploadImage(file));
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={onFile} data-testid={`${testid}-input`} />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        data-testid={testid}
        className={`btn-ghost px-3 py-2 text-[11px] tracking-[0.2em] uppercase inline-flex items-center gap-2 disabled:opacity-60 ${className}`}
      >
        <ImagePlus size={14} /> {busy ? "Uploading..." : label}
      </button>
    </>
  );
}

export function CoverField({ value, onChange }) {
  return (
    <div className="sm:col-span-2">
      <label className="block text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-2">Cover image (optional)</label>
      {value ? (
        <div className="relative w-full max-w-md aspect-video overflow-hidden border border-zinc-700 rounded-sm">
          <img src={resolveImageUrl(value)} alt="Cover preview" className="w-full h-full object-cover" data-testid="event-cover-preview" />
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute top-2 right-2 bg-black/70 p-1.5 rounded-full text-zinc-300 hover:text-crimson-bright"
            data-testid="event-cover-remove"
            aria-label="Remove cover"
          >
            <X size={14} />
          </button>
        </div>
      ) : (
        <ImageUploadButton onUploaded={onChange} testid="event-cover-upload" label="Upload Cover" />
      )}
    </div>
  );
}
